import React from 'react'
import { makeStyles } from "@material-ui/core"
import CustomButton from './CustomButton'

const useStyles = makeStyles((theme) => ({
  ...theme.styles.buttons.secondary
}))

const SecondaryButton = (props) => {
  const styles = useStyles()
  return <CustomButton
    {...props}
    styles={styles}
  />
}

export default SecondaryButton